export const environment = {
  production: true,
  mapbox: {
    accessToken: "pk.eyJ1IjoieHNrb2d6ZXJvcyIsImEiOiJja3BlbDY3MjYxbzlpMm9wZXgyZDV1dHBxIn0.cFy7iOlgiEyeE5bDwsYdFg"
  },
  serverBaseUrl: "http://pdpachuvas.ic.uff.br/api",
  socketIOUrl: "ws://pdpachuvas.ic.uff.br",
  imagesBaseUrl: "http://pdpachuvas.ic.uff.br/images",
};
